// @flow

import 'prelude';

import Modernizr from 'rgs-modernizr';
import $ from 'rgs-jquery';
import Q from 'q';
import 'rgs-velocity-animate';
import 'rgs-bootstrap';
import ko from 'rgs-knockout';
import _ from 'lodash';

import './js/yandex-data-api.js';
import './js/steps-accordion-api.js';
import './js/slide-data-api.js';
import './js/alignment-data-api.js';

import debugGlobals from 'debug-globals';

debugGlobals.extend({
	Modernizr,
	$,
	Q,
	_,
	ko,
});

debugGlobals();

import mainMenu from './js/rgs-main-menu.js';
import contextBar from './js/rgs-context-bar.js';
import notifications from './js/notifications.js';
import modals from 'modals';

const page = {
	mainMenu,
	contextBar,
	notifications,
	modals,
};

debugGlobals.extend({ page });

module.exports = page;
